import { ViolationService } from '../../../violations-sets/violation-service/violation.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DriversService } from '../../../drivers/drivers-service/drivers-service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import * as moment from 'moment';
import * as _ from 'underscore';
import { takeUntil } from 'rxjs/operators';
import { sweetAlert } from 'src/app/utils/swal';
import { ServiceAreasService } from '../../../service-areas/service-areas-service/service-areas.service';
import { getDistanceFromLatLonInKm, roundOffTime } from 'src/app/utils/utils.common';
import { AssigTripsService } from '../../assigntrips-service/assigntrips-service';
@Component({
  selector: 'app-planner-schedule-logs-modal',
  templateUrl: './planner-schedule-logs-modal.component.html',
  styleUrls: ['./planner-schedule-logs-modal.component.css']
})
export class PlannerScheduleLogsModalComponent implements OnInit {
  user: any;
  timeZone;
  driverTrips=[];
  @Input() preData;
  @Output() closeModal = new EventEmitter();

  constructor(
    private driverService: DriversService,
    private violationService: ViolationService,
    private sharedDataService: SharedDataService,
    private serviceArea: ServiceAreasService,
    private assignTripService: AssigTripsService,

  ) { }

  ngOnInit() {
    this.getUser();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.timeZone = this.user.timeZone;

        }
      });
  }


  closeScheduleLogsModal(){
    this.closeModal.emit()
  }

  selectedDriverTrips(key) {
    if(key){

      this.driverTrips = this.preData[key].reasons;

    }else{
      this.driverTrips = [];
    }
  }

  sortMethod(a, b) {
    return a.value.driver.displayName - b.value.driver.displayName 
  }



  ngOnDestroy(): void{

  }

}
